import { getNlsString } from '../../nls/nlsRuntime'

export const AccessDenied = ({ message = getNlsString('NLSCommonAccessDeniedDefaultMessage') }: { message?: string }) => (
  <main className="profileOnboardingGate" aria-label={getNlsString('NLSCommonAriaAccessDenied')}>
    <section className="profileOnboardingCard">
      <p className="settingsEyebrow">403</p>
      <h1>{getNlsString('NLSCommonAccessDeniedTitle')}</h1>
      <p>{message}</p>
    </section>
  </main>
)
